import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartContext = createContext(null);
const KEY = "rooftop_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });
  const [bump, setBump] = useState(0);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((item) => {
    setItems((prev) => {
      const key = (it) => it.product_id + "|" + JSON.stringify(it.variant_selections || []) + "|" + JSON.stringify((it.design_files || []).map((d) => d.file_id)) + "|" + (it.notes || "");
      const idx = prev.findIndex((i) => key(i) === key(item));
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + item.quantity };
        return next;
      }
      return [...prev, { ...item, cart_id: Date.now() + "_" + Math.random().toString(36).slice(2, 7) }];
    });
    setBump((b) => b + 1);
  }, []);

  const removeItem = useCallback((cart_id) => {
    setItems((prev) => prev.filter((i) => i.cart_id !== cart_id));
  }, []);

  const updateQty = useCallback((cart_id, quantity) => {
    setItems((prev) => prev.map((i) => (i.cart_id === cart_id ? { ...i, quantity: Math.max(1, quantity) } : i)));
  }, []);

  const clearCart = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clearCart, count, subtotal, bump }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
